// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1wBRn","label":"Labeled_label__2crs3","divider":"Labeled_divider__2rVSS"};